import { render, staticRenderFns } from "./ViewPersonEmergencyContactDialog.vue?vue&type=template&id=86a6fe3e&scoped=true&"
import script from "./ViewPersonEmergencyContactDialog.vue?vue&type=script&lang=js&"
export * from "./ViewPersonEmergencyContactDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a6fe3e",
  null
  
)

export default component.exports